var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33474_37239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V21H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33474_37239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 10.5C13.7812 12.3122 12.3122 13.7812 10.5 13.7812C8.68781 13.7812 7.21875 12.3122 7.21875 10.5C7.21875 8.68781 8.68781 7.21875 10.5 7.21875C12.3122 7.21875 13.7812 8.68781 13.7812 10.5Z",
    stroke: "#3CB4E5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0259 10.5C20.0259 10.5 15.9366 17.0625 10.5 17.0625C5.06342 17.0625 0.974121 10.5 0.974121 10.5C0.974121 10.5 5.06342 3.9375 10.5 3.9375C15.9366 3.9375 20.0259 10.5 20.0259 10.5Z",
    stroke: "#3CB4E5",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEyeIcon);
export default __webpack_public_path__ + "static/media/blueEyeIcon.780c62a74ee34a4b8f4f125113798d98.svg";
export { ForwardRef as ReactComponent };